import { render, staticRenderFns } from "./LinkedTags.vue?vue&type=template&id=2c4aaaa2&scoped=true&"
import script from "./LinkedTags.vue?vue&type=script&lang=js&"
export * from "./LinkedTags.vue?vue&type=script&lang=js&"
import style0 from "./LinkedTags.vue?vue&type=style&index=0&id=2c4aaaa2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4aaaa2",
  null
  
)

export default component.exports